<template>
  <div class="CartVariant" v-if="cartItemslist.product_type==2">
			 <div class="p-0 m-0" v-for="(item, index) in cartItemslist.variation_attributes" :key="item">
				<small><span class="text-capitalize "><!-- font-weight-bold -->  {{item}}: </span>
				<span class="text-uppercase">{{cartItemslist.variations_selected[index]}}</span></small>
				
			</div>
   
  </div>
</template>
<script>
export default {
  name: 'CartVariant',
  props: {
    cartItemslist: { type: Object }
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">

</style>
